/**
 * Converts a string to an object with a single property `translatedText`.
 * @param {string} string - The string to be converted.
 * @returns {Object} An object with a single property `translatedText` containing the input string.
 */
export function convertToObject(string) {
  return { translatedText: string }
}
